/** @return {object} - get selected delivery object */
const getDelivery = state => {
  return state.delivery;
};
/** @return {object} - get selected delivery date start */
const getDeliverySelectedDateStart = state => {
  return state.delivery.deliveryDateStart;
};

/** @return {object} - get selected delivery hours */
const getDeliverySelectedHours = state => {
  return state.delivery.selectedHours;
};

/** @return {object} - get selected delivery id */
const getDeliverySelectedId = state => {
  return state.delivery.id;
};

/** @return {object} - get selected delivery id */
const getDeliveryCurrentId = state => {
  return state.delivery.currentId;
};

/** @return {object} - get selected delivery id */
const getDeliverySelectedPostalCode = state => {
  return state.delivery.postalCode;
};

/** @return {object} - get selected delivery previous call for modification ( agencies, slots ... ) */
const getSelectedDeliveryAgenciesData = state => {
  return state.delivery.responseData.agenciesData;
};
/** @return {object} - get selected delivery previous call for modification ( agencies, slots ... ) */
const getSelectedDeliveryCalendarData = state => {
  return state.delivery.responseData.calendarData;
};


//For start Countdown
const getUpdateDateForSlotSelectDelivery = state => {
  return state.delivery.slotAvailability.slotUpdatedAt;
};

// Get current date ans time from server for countdown compare
const getServerDateNow = state => {
  return state.delivery.slotAvailability.serverDate
}

const getDeliveryDateAvailability = state => {
  return state.delivery.isDeliveryDateAvailable;
};

export default {
  getDelivery,
  getDeliverySelectedDateStart,
  getDeliverySelectedHours,
  getDeliverySelectedId,
  getDeliveryCurrentId,
  getSelectedDeliveryAgenciesData,
  getSelectedDeliveryCalendarData,
  getDeliverySelectedPostalCode,
  getUpdateDateForSlotSelectDelivery,
  getServerDateNow,
  getDeliveryDateAvailability
};
